<script lang="ts">
import {afterUpdate, onMount} from "svelte";
import { movable } from '@svelte-put/movable';
import {createEventDispatcher} from "svelte";
import {Spinner} from "flowbite-svelte";

export let data = [];
export let header;

export let emptyText = 'No data to display'

export let hideHeader = false;

export let rowClick: Function = () => {};

let rendering = false;
let moving = false;
const dispatch = createEventDispatcher()

const sorting = headerItem => {
    headerItem.sort = typeof headerItem.sort === 'undefined' ? 1 : -1 * headerItem.sort

    if(headerItem.hasOwnProperty('customSort')){
        data = data.sort((a,b) => headerItem.customSort(a,b,headerItem.sort))
    } else {
        data = data.sort((a,b) => {
            if(typeof a[headerItem.property] !== 'undefined' && typeof a[headerItem.property].stamp !== 'undefined'){
                return a[headerItem.property].stamp < b[headerItem.property].stamp ? -1 * headerItem.sort : headerItem.sort
            }
            return a[headerItem.property] < b[headerItem.property] ? -1 * headerItem.sort : headerItem.sort
        })
    }


    dispatch('sort', {
        property: headerItem.property,
        order: headerItem.sort
    })
}
const rearrange = (moved, index) => {
    if(Math.abs(moved.position.left) < 25){
        return;
    }

    moving = false;
    rendering = true;
    let offsets = [];
    for(let i = 0; i < targetRef.childNodes.length; i++){
        offsets.push(targetRef.childNodes[i].clientWidth);
    }
    let runningOffset = 0;
    if(moved.position.left > 0){
        for(let i = index; i < offsets.length; i++){
            runningOffset += offsets[i];
            if(moved.position.left < runningOffset){
                header.move(index, i)
                break;
            }
        }
    } else {
        for(let i = index -1; i >=0; i--){
            runningOffset += offsets[i];
            if(moved.position.left*-1 < runningOffset){
                header.move(index, i)
                break;
            }
        }
    }


    setTimeout(() => {
        rendering = false;
    },1)

}
afterUpdate(()=>{

})
onMount(()=>{
    console.log(data);
})

let targetRef = null;
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

</script>
<style>
    :global(.dragged) {
        pointer-events: none;
        z-index: 100;
    }
</style>
<div class="mt-3 flow-root py-3">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                {#if data && data.length < 1}
                    <slot name="empty">
                    <div class="px-3 py-2 text-neutral-500 flex gap-2">
                        <svg class="text-red-400 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></path>
                        </svg>
                        {emptyText}
                    </div>
                    </slot>
                {:else if rendering}
                    <div class="text-center my-5">
                        <Spinner/>
                    </div>
                {:else}
                    <table class="min-w-full divide-y divide-gray-300">
                        {#if !hideHeader}
                        <thead class="bg-gray-50 dark:bg-gray-500">

                        <tr bind:this={targetRef}>
                            {#each header.filter(h => typeof h.hidden === 'undefined' || !h.hidden) as th, index}
                                <th scope="col" class="{th.class ?? ''} {moving ? 'border-r' : ''}  pl-3 pr-3 text-left text-sm font-semibold text-neutral-600 dark:text-white sm:pl-5">
                                    {#each [th] as th}
                                    <div
                                        use:movable={{limit: {parent:targetRef}, enabled: th.movable, handle: document.querySelector('#handle-' + index)}}
                                        on:movableend={ev => rearrange(ev.detail, index)}
                                        on:movablestart={() => moving = true}
                                        class="flex gap-2 relative label h-full py-3.5" >

                                        <div id={'handle-' + index} >
                                            {th.label}
                                        </div>
                                        {#if th.sortable}
                                            <svg on:click={() => sorting(th)} class="w-4 cursor-pointer " fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                                            </svg>
                                        {/if}
                                        <!--{#if th.movable}
                                        <div
                                                on:drag={ev => ev.target.style.scale = .75}
                                                on:dropped={ev => rearrange(ev.detail, index)}
                                                use:draggable={{data: th, targets: ['.droppable', '.droppable svg', '.droppable svg path']}}
                                             class="px-2 py-0.5 border rounded border-neutral-500 relative droppable">
                                            <svg on:dropped={ev => rearrange(ev.detail, index)} class="w-4 cursor-pointer" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"></path>
                                            </svg>
                                        </div>
                                        {/if}-->
                                    </div>
                                    {/each}
                                </th>
                            {/each}
                        </tr>

                        </thead>
                        {/if}
                        <tbody class="divide-y divide-gray-200 bg-white dark:bg-gray-700">
                        {#each data as item, index}
                        <tr on:click={() => rowClick && rowClick(item)} class="{rowClick ? 'cursor-pointer' : ''}">
                            {#each header.filter(h => typeof h.hidden === 'undefined' || !h.hidden) as td}
                            <td class="whitespace-nowrap pl-5 pr-3 py-4 text-sm text-neutral-700 dark:text-gray-300">
                                {#if td.component && td.property === 'index'}
                                    <svelte:component this={td.component} {...td.props} {item} value={index}/>
                                {:else if td.component}
                                    <svelte:component this={td.component} {...td.props} bind:value={item[td.property]}/>
                                {:else if td.render}
                                    {@html td.render(item)}
                                {:else}
                                    {item[td.property]}
                                {/if}

                            </td>

                            {/each}
                        </tr>
                        {/each}

                        </tbody>
                    </table>
                {/if}
            </div>
        </div>
    </div>
</div>